import React from 'react';
import { Grid, Skeleton, Typography, useMediaQuery } from '@mui/material';
import RnRForm from './RnRForm';
import RnRHistory from './RnRHistory';
import { variants } from '../../../../variants/variants';
import { useGetActiveQuarterQuery, useGetNominationByNomineeEmpCodeQuery } from '../../rnrApiSlice';
import { useParams } from 'react-router-dom';
import RnRNotStarted from './RnRNotStarted';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';
import { useTheme } from '@mui/material/styles';

const RnRDrawer = () => {
  const { empCode } = useParams();
  const { data: currentQuarter, isLoading: isQuarterLoading } = useGetActiveQuarterQuery();
  const { data: nominations, isLoading, error } = useGetNominationByNomineeEmpCodeQuery(empCode);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const isCurrentQuarterActive = () => {
    if (!currentQuarter?.data || !currentQuarter?.data?.endDate) {
      return false;
    }
    else if (new Date(currentQuarter?.data?.endDate) >= new Date() && new Date(currentQuarter?.data?.startDate) <= new Date()) {
      return currentQuarter?.data?.active;
    }
    else{
      return false;
    }
  };
  
  return (
    <Grid 
      container 
      p={2} 
      sx={{
        height:'100%', // Adjust height for mobile
        flexDirection: 'row', 
        overflowY: 'auto',
      }}
    >
      <Grid
        item
        xl={12}
        mb={2}
        sx={{ 
          height: isKeyboardOpen ? 'calc(60vh)' : 'calc(82vh)', 
          overflowX: 'hidden', 
          overflowY: 'auto',
          [theme.breakpoints.down('sm')]: {
            height: isKeyboardOpen ? 'calc(70vh)' : 'auto', // Adjust height for small screens
          },
        }}
      >
        {isCurrentQuarterActive() ? <RnRForm /> : <RnRNotStarted />}
      </Grid>

      {/* {isKeyboardOpen ? null : (
        <>
          {isLoading || isQuarterLoading ? (
            <Skeleton variant="rectangular" height={30} width={200} sx={{ mb: 1 }} />
          ) : (
            <Typography 
              fontSize={variants.fontSize.HEADING} 
              fontWeight="bold" 
              sx={{ mb: 1 }}
            >
              Previous RnR History
            </Typography>
          )}

         
            <RnRHistory nominations={nominations} isLoading={isLoading} error={error} />
        </>
       )}  */}
    </Grid>
  );
};

export default RnRDrawer;
